/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var extproto_ext_pb = require('../../../../../../../../../../extproto/ext_pb.js');
var validate_validate_pb = require('../../../../../../../../../../validate/validate_pb.js');
var github_com_solo$io_solo$kit_api_v1_ref_pb = require('../../../../../../../../../../github.com/solo-io/solo-kit/api/v1/ref_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_v1_filters_stages_pb = require('../../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/v1/filters/stages_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_common_mutation_rules_v3_mutation_rules_pb = require('../../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/external/envoy/config/common/mutation_rules/v3/mutation_rules_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb = require('../../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/external/envoy/config/core/v3/base_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb = require('../../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/external/envoy/extensions/filters/http/ext_proc/v3/processing_mode_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb = require('../../../../../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/external/envoy/type/matcher/v3/string_pb.js');
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.exportSymbol('proto.extproc.options.gloo.solo.io.GrpcService', null, global);
goog.exportSymbol('proto.extproc.options.gloo.solo.io.HeaderForwardingRules', null, global);
goog.exportSymbol('proto.extproc.options.gloo.solo.io.Overrides', null, global);
goog.exportSymbol('proto.extproc.options.gloo.solo.io.RouteSettings', null, global);
goog.exportSymbol('proto.extproc.options.gloo.solo.io.Settings', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.extproc.options.gloo.solo.io.Settings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.extproc.options.gloo.solo.io.Settings.repeatedFields_, null);
};
goog.inherits(proto.extproc.options.gloo.solo.io.Settings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.extproc.options.gloo.solo.io.Settings.displayName = 'proto.extproc.options.gloo.solo.io.Settings';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.extproc.options.gloo.solo.io.Settings.repeatedFields_ = [6,7,16,17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.toObject = function(opt_includeInstance) {
  return proto.extproc.options.gloo.solo.io.Settings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.extproc.options.gloo.solo.io.Settings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.extproc.options.gloo.solo.io.Settings.toObject = function(includeInstance, msg) {
  var f, obj = {
    grpcService: (f = msg.getGrpcService()) && proto.extproc.options.gloo.solo.io.GrpcService.toObject(includeInstance, f),
    filterStage: (f = msg.getFilterStage()) && github_com_solo$io_solo$apis_api_gloo_gloo_v1_filters_stages_pb.FilterStage.toObject(includeInstance, f),
    failureModeAllow: (f = msg.getFailureModeAllow()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    processingMode: (f = msg.getProcessingMode()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb.ProcessingMode.toObject(includeInstance, f),
    asyncMode: (f = msg.getAsyncMode()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    requestAttributesList: jspb.Message.getRepeatedField(msg, 6),
    responseAttributesList: jspb.Message.getRepeatedField(msg, 7),
    messageTimeout: (f = msg.getMessageTimeout()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    statPrefix: (f = msg.getStatPrefix()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    mutationRules: (f = msg.getMutationRules()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_common_mutation_rules_v3_mutation_rules_pb.HeaderMutationRules.toObject(includeInstance, f),
    maxMessageTimeout: (f = msg.getMaxMessageTimeout()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    disableClearRouteCache: (f = msg.getDisableClearRouteCache()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    forwardRules: (f = msg.getForwardRules()) && proto.extproc.options.gloo.solo.io.HeaderForwardingRules.toObject(includeInstance, f),
    filterMetadata: (f = msg.getFilterMetadata()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    allowModeOverride: (f = msg.getAllowModeOverride()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    metadataContextNamespacesList: jspb.Message.getRepeatedField(msg, 16),
    typedMetadataContextNamespacesList: jspb.Message.getRepeatedField(msg, 17)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.extproc.options.gloo.solo.io.Settings}
 */
proto.extproc.options.gloo.solo.io.Settings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.extproc.options.gloo.solo.io.Settings;
  return proto.extproc.options.gloo.solo.io.Settings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.extproc.options.gloo.solo.io.Settings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.extproc.options.gloo.solo.io.Settings}
 */
proto.extproc.options.gloo.solo.io.Settings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.extproc.options.gloo.solo.io.GrpcService;
      reader.readMessage(value,proto.extproc.options.gloo.solo.io.GrpcService.deserializeBinaryFromReader);
      msg.setGrpcService(value);
      break;
    case 2:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_v1_filters_stages_pb.FilterStage;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_v1_filters_stages_pb.FilterStage.deserializeBinaryFromReader);
      msg.setFilterStage(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setFailureModeAllow(value);
      break;
    case 4:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb.ProcessingMode;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb.ProcessingMode.deserializeBinaryFromReader);
      msg.setProcessingMode(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setAsyncMode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addRequestAttributes(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addResponseAttributes(value);
      break;
    case 8:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setMessageTimeout(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStatPrefix(value);
      break;
    case 10:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_common_mutation_rules_v3_mutation_rules_pb.HeaderMutationRules;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_common_mutation_rules_v3_mutation_rules_pb.HeaderMutationRules.deserializeBinaryFromReader);
      msg.setMutationRules(value);
      break;
    case 11:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setMaxMessageTimeout(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setDisableClearRouteCache(value);
      break;
    case 13:
      var value = new proto.extproc.options.gloo.solo.io.HeaderForwardingRules;
      reader.readMessage(value,proto.extproc.options.gloo.solo.io.HeaderForwardingRules.deserializeBinaryFromReader);
      msg.setForwardRules(value);
      break;
    case 14:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setFilterMetadata(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setAllowModeOverride(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.addMetadataContextNamespaces(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.addTypedMetadataContextNamespaces(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.extproc.options.gloo.solo.io.Settings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.extproc.options.gloo.solo.io.Settings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.extproc.options.gloo.solo.io.Settings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGrpcService();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.extproc.options.gloo.solo.io.GrpcService.serializeBinaryToWriter
    );
  }
  f = message.getFilterStage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_v1_filters_stages_pb.FilterStage.serializeBinaryToWriter
    );
  }
  f = message.getFailureModeAllow();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getProcessingMode();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb.ProcessingMode.serializeBinaryToWriter
    );
  }
  f = message.getAsyncMode();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRequestAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getResponseAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getMessageTimeout();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getStatPrefix();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMutationRules();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_common_mutation_rules_v3_mutation_rules_pb.HeaderMutationRules.serializeBinaryToWriter
    );
  }
  f = message.getMaxMessageTimeout();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getDisableClearRouteCache();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getForwardRules();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.extproc.options.gloo.solo.io.HeaderForwardingRules.serializeBinaryToWriter
    );
  }
  f = message.getFilterMetadata();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getAllowModeOverride();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMetadataContextNamespacesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      16,
      f
    );
  }
  f = message.getTypedMetadataContextNamespacesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      17,
      f
    );
  }
};


/**
 * optional GrpcService grpc_service = 1;
 * @return {?proto.extproc.options.gloo.solo.io.GrpcService}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getGrpcService = function() {
  return /** @type{?proto.extproc.options.gloo.solo.io.GrpcService} */ (
    jspb.Message.getWrapperField(this, proto.extproc.options.gloo.solo.io.GrpcService, 1));
};


/** @param {?proto.extproc.options.gloo.solo.io.GrpcService|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setGrpcService = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearGrpcService = function() {
  this.setGrpcService(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasGrpcService = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional filters.gloo.solo.io.FilterStage filter_stage = 2;
 * @return {?proto.filters.gloo.solo.io.FilterStage}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getFilterStage = function() {
  return /** @type{?proto.filters.gloo.solo.io.FilterStage} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_v1_filters_stages_pb.FilterStage, 2));
};


/** @param {?proto.filters.gloo.solo.io.FilterStage|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setFilterStage = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearFilterStage = function() {
  this.setFilterStage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasFilterStage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue failure_mode_allow = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getFailureModeAllow = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setFailureModeAllow = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearFailureModeAllow = function() {
  this.setFailureModeAllow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasFailureModeAllow = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional solo.io.envoy.extensions.filters.http.ext_proc.v3.ProcessingMode processing_mode = 4;
 * @return {?proto.solo.io.envoy.extensions.filters.http.ext_proc.v3.ProcessingMode}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getProcessingMode = function() {
  return /** @type{?proto.solo.io.envoy.extensions.filters.http.ext_proc.v3.ProcessingMode} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb.ProcessingMode, 4));
};


/** @param {?proto.solo.io.envoy.extensions.filters.http.ext_proc.v3.ProcessingMode|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setProcessingMode = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearProcessingMode = function() {
  this.setProcessingMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasProcessingMode = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue async_mode = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getAsyncMode = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setAsyncMode = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearAsyncMode = function() {
  this.setAsyncMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasAsyncMode = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated string request_attributes = 6;
 * @return {!Array<string>}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getRequestAttributesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<string>} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setRequestAttributesList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.addRequestAttributes = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearRequestAttributesList = function() {
  this.setRequestAttributesList([]);
};


/**
 * repeated string response_attributes = 7;
 * @return {!Array<string>}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getResponseAttributesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/** @param {!Array<string>} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setResponseAttributesList = function(value) {
  jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.addResponseAttributes = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearResponseAttributesList = function() {
  this.setResponseAttributesList([]);
};


/**
 * optional google.protobuf.Duration message_timeout = 8;
 * @return {?proto.google.protobuf.Duration}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getMessageTimeout = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 8));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setMessageTimeout = function(value) {
  jspb.Message.setWrapperField(this, 8, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearMessageTimeout = function() {
  this.setMessageTimeout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasMessageTimeout = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue stat_prefix = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getStatPrefix = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/** @param {?proto.google.protobuf.StringValue|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setStatPrefix = function(value) {
  jspb.Message.setWrapperField(this, 9, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearStatPrefix = function() {
  this.setStatPrefix(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasStatPrefix = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional solo.io.envoy.config.common.mutation_rules.v3.HeaderMutationRules mutation_rules = 10;
 * @return {?proto.solo.io.envoy.config.common.mutation_rules.v3.HeaderMutationRules}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getMutationRules = function() {
  return /** @type{?proto.solo.io.envoy.config.common.mutation_rules.v3.HeaderMutationRules} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_common_mutation_rules_v3_mutation_rules_pb.HeaderMutationRules, 10));
};


/** @param {?proto.solo.io.envoy.config.common.mutation_rules.v3.HeaderMutationRules|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setMutationRules = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearMutationRules = function() {
  this.setMutationRules(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasMutationRules = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Duration max_message_timeout = 11;
 * @return {?proto.google.protobuf.Duration}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getMaxMessageTimeout = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 11));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setMaxMessageTimeout = function(value) {
  jspb.Message.setWrapperField(this, 11, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearMaxMessageTimeout = function() {
  this.setMaxMessageTimeout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasMaxMessageTimeout = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.BoolValue disable_clear_route_cache = 12;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getDisableClearRouteCache = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 12));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setDisableClearRouteCache = function(value) {
  jspb.Message.setWrapperField(this, 12, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearDisableClearRouteCache = function() {
  this.setDisableClearRouteCache(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasDisableClearRouteCache = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional HeaderForwardingRules forward_rules = 13;
 * @return {?proto.extproc.options.gloo.solo.io.HeaderForwardingRules}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getForwardRules = function() {
  return /** @type{?proto.extproc.options.gloo.solo.io.HeaderForwardingRules} */ (
    jspb.Message.getWrapperField(this, proto.extproc.options.gloo.solo.io.HeaderForwardingRules, 13));
};


/** @param {?proto.extproc.options.gloo.solo.io.HeaderForwardingRules|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setForwardRules = function(value) {
  jspb.Message.setWrapperField(this, 13, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearForwardRules = function() {
  this.setForwardRules(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasForwardRules = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Struct filter_metadata = 14;
 * @return {?proto.google.protobuf.Struct}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getFilterMetadata = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 14));
};


/** @param {?proto.google.protobuf.Struct|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setFilterMetadata = function(value) {
  jspb.Message.setWrapperField(this, 14, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearFilterMetadata = function() {
  this.setFilterMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasFilterMetadata = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.BoolValue allow_mode_override = 15;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getAllowModeOverride = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 15));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setAllowModeOverride = function(value) {
  jspb.Message.setWrapperField(this, 15, value);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearAllowModeOverride = function() {
  this.setAllowModeOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.hasAllowModeOverride = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated string metadata_context_namespaces = 16;
 * @return {!Array<string>}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getMetadataContextNamespacesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};


/** @param {!Array<string>} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setMetadataContextNamespacesList = function(value) {
  jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.addMetadataContextNamespaces = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearMetadataContextNamespacesList = function() {
  this.setMetadataContextNamespacesList([]);
};


/**
 * repeated string typed_metadata_context_namespaces = 17;
 * @return {!Array<string>}
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.getTypedMetadataContextNamespacesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};


/** @param {!Array<string>} value */
proto.extproc.options.gloo.solo.io.Settings.prototype.setTypedMetadataContextNamespacesList = function(value) {
  jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.extproc.options.gloo.solo.io.Settings.prototype.addTypedMetadataContextNamespaces = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


proto.extproc.options.gloo.solo.io.Settings.prototype.clearTypedMetadataContextNamespacesList = function() {
  this.setTypedMetadataContextNamespacesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.extproc.options.gloo.solo.io.RouteSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.extproc.options.gloo.solo.io.RouteSettings.oneofGroups_);
};
goog.inherits(proto.extproc.options.gloo.solo.io.RouteSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.extproc.options.gloo.solo.io.RouteSettings.displayName = 'proto.extproc.options.gloo.solo.io.RouteSettings';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.extproc.options.gloo.solo.io.RouteSettings.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.extproc.options.gloo.solo.io.RouteSettings.OverrideCase = {
  OVERRIDE_NOT_SET: 0,
  DISABLED: 1,
  OVERRIDES: 2
};

/**
 * @return {proto.extproc.options.gloo.solo.io.RouteSettings.OverrideCase}
 */
proto.extproc.options.gloo.solo.io.RouteSettings.prototype.getOverrideCase = function() {
  return /** @type {proto.extproc.options.gloo.solo.io.RouteSettings.OverrideCase} */(jspb.Message.computeOneofCase(this, proto.extproc.options.gloo.solo.io.RouteSettings.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.extproc.options.gloo.solo.io.RouteSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.extproc.options.gloo.solo.io.RouteSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.extproc.options.gloo.solo.io.RouteSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.extproc.options.gloo.solo.io.RouteSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    disabled: (f = msg.getDisabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    overrides: (f = msg.getOverrides()) && proto.extproc.options.gloo.solo.io.Overrides.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.extproc.options.gloo.solo.io.RouteSettings}
 */
proto.extproc.options.gloo.solo.io.RouteSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.extproc.options.gloo.solo.io.RouteSettings;
  return proto.extproc.options.gloo.solo.io.RouteSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.extproc.options.gloo.solo.io.RouteSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.extproc.options.gloo.solo.io.RouteSettings}
 */
proto.extproc.options.gloo.solo.io.RouteSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setDisabled(value);
      break;
    case 2:
      var value = new proto.extproc.options.gloo.solo.io.Overrides;
      reader.readMessage(value,proto.extproc.options.gloo.solo.io.Overrides.deserializeBinaryFromReader);
      msg.setOverrides(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.extproc.options.gloo.solo.io.RouteSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.extproc.options.gloo.solo.io.RouteSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.extproc.options.gloo.solo.io.RouteSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.extproc.options.gloo.solo.io.RouteSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisabled();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getOverrides();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.extproc.options.gloo.solo.io.Overrides.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.BoolValue disabled = 1;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.extproc.options.gloo.solo.io.RouteSettings.prototype.getDisabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 1));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.extproc.options.gloo.solo.io.RouteSettings.prototype.setDisabled = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.extproc.options.gloo.solo.io.RouteSettings.oneofGroups_[0], value);
};


proto.extproc.options.gloo.solo.io.RouteSettings.prototype.clearDisabled = function() {
  this.setDisabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.RouteSettings.prototype.hasDisabled = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Overrides overrides = 2;
 * @return {?proto.extproc.options.gloo.solo.io.Overrides}
 */
proto.extproc.options.gloo.solo.io.RouteSettings.prototype.getOverrides = function() {
  return /** @type{?proto.extproc.options.gloo.solo.io.Overrides} */ (
    jspb.Message.getWrapperField(this, proto.extproc.options.gloo.solo.io.Overrides, 2));
};


/** @param {?proto.extproc.options.gloo.solo.io.Overrides|undefined} value */
proto.extproc.options.gloo.solo.io.RouteSettings.prototype.setOverrides = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.extproc.options.gloo.solo.io.RouteSettings.oneofGroups_[0], value);
};


proto.extproc.options.gloo.solo.io.RouteSettings.prototype.clearOverrides = function() {
  this.setOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.RouteSettings.prototype.hasOverrides = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.extproc.options.gloo.solo.io.GrpcService = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.extproc.options.gloo.solo.io.GrpcService.repeatedFields_, null);
};
goog.inherits(proto.extproc.options.gloo.solo.io.GrpcService, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.extproc.options.gloo.solo.io.GrpcService.displayName = 'proto.extproc.options.gloo.solo.io.GrpcService';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.extproc.options.gloo.solo.io.GrpcService.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.toObject = function(opt_includeInstance) {
  return proto.extproc.options.gloo.solo.io.GrpcService.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.extproc.options.gloo.solo.io.GrpcService} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.extproc.options.gloo.solo.io.GrpcService.toObject = function(includeInstance, msg) {
  var f, obj = {
    extProcServerRef: (f = msg.getExtProcServerRef()) && github_com_solo$io_solo$kit_api_v1_ref_pb.ResourceRef.toObject(includeInstance, f),
    authority: (f = msg.getAuthority()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    retryPolicy: (f = msg.getRetryPolicy()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb.RetryPolicy.toObject(includeInstance, f),
    timeout: (f = msg.getTimeout()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    initialMetadataList: jspb.Message.toObjectList(msg.getInitialMetadataList(),
    github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb.HeaderValue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.extproc.options.gloo.solo.io.GrpcService}
 */
proto.extproc.options.gloo.solo.io.GrpcService.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.extproc.options.gloo.solo.io.GrpcService;
  return proto.extproc.options.gloo.solo.io.GrpcService.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.extproc.options.gloo.solo.io.GrpcService} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.extproc.options.gloo.solo.io.GrpcService}
 */
proto.extproc.options.gloo.solo.io.GrpcService.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_solo$kit_api_v1_ref_pb.ResourceRef;
      reader.readMessage(value,github_com_solo$io_solo$kit_api_v1_ref_pb.ResourceRef.deserializeBinaryFromReader);
      msg.setExtProcServerRef(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAuthority(value);
      break;
    case 3:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb.RetryPolicy;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb.RetryPolicy.deserializeBinaryFromReader);
      msg.setRetryPolicy(value);
      break;
    case 4:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTimeout(value);
      break;
    case 5:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb.HeaderValue;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb.HeaderValue.deserializeBinaryFromReader);
      msg.addInitialMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.extproc.options.gloo.solo.io.GrpcService.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.extproc.options.gloo.solo.io.GrpcService} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.extproc.options.gloo.solo.io.GrpcService.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtProcServerRef();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_solo$kit_api_v1_ref_pb.ResourceRef.serializeBinaryToWriter
    );
  }
  f = message.getAuthority();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRetryPolicy();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb.RetryPolicy.serializeBinaryToWriter
    );
  }
  f = message.getTimeout();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getInitialMetadataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb.HeaderValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional core.solo.io.ResourceRef ext_proc_server_ref = 1;
 * @return {?proto.core.solo.io.ResourceRef}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.getExtProcServerRef = function() {
  return /** @type{?proto.core.solo.io.ResourceRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$kit_api_v1_ref_pb.ResourceRef, 1));
};


/** @param {?proto.core.solo.io.ResourceRef|undefined} value */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.setExtProcServerRef = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.extproc.options.gloo.solo.io.GrpcService.prototype.clearExtProcServerRef = function() {
  this.setExtProcServerRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.hasExtProcServerRef = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue authority = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.getAuthority = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/** @param {?proto.google.protobuf.StringValue|undefined} value */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.setAuthority = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.extproc.options.gloo.solo.io.GrpcService.prototype.clearAuthority = function() {
  this.setAuthority(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.hasAuthority = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional solo.io.envoy.config.core.v3.RetryPolicy retry_policy = 3;
 * @return {?proto.solo.io.envoy.config.core.v3.RetryPolicy}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.getRetryPolicy = function() {
  return /** @type{?proto.solo.io.envoy.config.core.v3.RetryPolicy} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb.RetryPolicy, 3));
};


/** @param {?proto.solo.io.envoy.config.core.v3.RetryPolicy|undefined} value */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.setRetryPolicy = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.extproc.options.gloo.solo.io.GrpcService.prototype.clearRetryPolicy = function() {
  this.setRetryPolicy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.hasRetryPolicy = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Duration timeout = 4;
 * @return {?proto.google.protobuf.Duration}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.getTimeout = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 4));
};


/** @param {?proto.google.protobuf.Duration|undefined} value */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.setTimeout = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.extproc.options.gloo.solo.io.GrpcService.prototype.clearTimeout = function() {
  this.setTimeout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.hasTimeout = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated solo.io.envoy.config.core.v3.HeaderValue initial_metadata = 5;
 * @return {!Array<!proto.solo.io.envoy.config.core.v3.HeaderValue>}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.getInitialMetadataList = function() {
  return /** @type{!Array<!proto.solo.io.envoy.config.core.v3.HeaderValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_config_core_v3_base_pb.HeaderValue, 5));
};


/** @param {!Array<!proto.solo.io.envoy.config.core.v3.HeaderValue>} value */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.setInitialMetadataList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.solo.io.envoy.config.core.v3.HeaderValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.solo.io.envoy.config.core.v3.HeaderValue}
 */
proto.extproc.options.gloo.solo.io.GrpcService.prototype.addInitialMetadata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.solo.io.envoy.config.core.v3.HeaderValue, opt_index);
};


proto.extproc.options.gloo.solo.io.GrpcService.prototype.clearInitialMetadataList = function() {
  this.setInitialMetadataList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.extproc.options.gloo.solo.io.Overrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.extproc.options.gloo.solo.io.Overrides.repeatedFields_, null);
};
goog.inherits(proto.extproc.options.gloo.solo.io.Overrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.extproc.options.gloo.solo.io.Overrides.displayName = 'proto.extproc.options.gloo.solo.io.Overrides';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.extproc.options.gloo.solo.io.Overrides.repeatedFields_ = [3,4,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.toObject = function(opt_includeInstance) {
  return proto.extproc.options.gloo.solo.io.Overrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.extproc.options.gloo.solo.io.Overrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.extproc.options.gloo.solo.io.Overrides.toObject = function(includeInstance, msg) {
  var f, obj = {
    processingMode: (f = msg.getProcessingMode()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb.ProcessingMode.toObject(includeInstance, f),
    asyncMode: (f = msg.getAsyncMode()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    requestAttributesList: jspb.Message.getRepeatedField(msg, 3),
    responseAttributesList: jspb.Message.getRepeatedField(msg, 4),
    grpcService: (f = msg.getGrpcService()) && proto.extproc.options.gloo.solo.io.GrpcService.toObject(includeInstance, f),
    metadataContextNamespacesList: jspb.Message.getRepeatedField(msg, 6),
    typedMetadataContextNamespacesList: jspb.Message.getRepeatedField(msg, 7)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.extproc.options.gloo.solo.io.Overrides}
 */
proto.extproc.options.gloo.solo.io.Overrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.extproc.options.gloo.solo.io.Overrides;
  return proto.extproc.options.gloo.solo.io.Overrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.extproc.options.gloo.solo.io.Overrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.extproc.options.gloo.solo.io.Overrides}
 */
proto.extproc.options.gloo.solo.io.Overrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb.ProcessingMode;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb.ProcessingMode.deserializeBinaryFromReader);
      msg.setProcessingMode(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setAsyncMode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addRequestAttributes(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addResponseAttributes(value);
      break;
    case 5:
      var value = new proto.extproc.options.gloo.solo.io.GrpcService;
      reader.readMessage(value,proto.extproc.options.gloo.solo.io.GrpcService.deserializeBinaryFromReader);
      msg.setGrpcService(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addMetadataContextNamespaces(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addTypedMetadataContextNamespaces(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.extproc.options.gloo.solo.io.Overrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.extproc.options.gloo.solo.io.Overrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.extproc.options.gloo.solo.io.Overrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProcessingMode();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb.ProcessingMode.serializeBinaryToWriter
    );
  }
  f = message.getAsyncMode();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRequestAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getResponseAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getGrpcService();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.extproc.options.gloo.solo.io.GrpcService.serializeBinaryToWriter
    );
  }
  f = message.getMetadataContextNamespacesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getTypedMetadataContextNamespacesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
};


/**
 * optional solo.io.envoy.extensions.filters.http.ext_proc.v3.ProcessingMode processing_mode = 1;
 * @return {?proto.solo.io.envoy.extensions.filters.http.ext_proc.v3.ProcessingMode}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.getProcessingMode = function() {
  return /** @type{?proto.solo.io.envoy.extensions.filters.http.ext_proc.v3.ProcessingMode} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_extensions_filters_http_ext_proc_v3_processing_mode_pb.ProcessingMode, 1));
};


/** @param {?proto.solo.io.envoy.extensions.filters.http.ext_proc.v3.ProcessingMode|undefined} value */
proto.extproc.options.gloo.solo.io.Overrides.prototype.setProcessingMode = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.extproc.options.gloo.solo.io.Overrides.prototype.clearProcessingMode = function() {
  this.setProcessingMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.hasProcessingMode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.BoolValue async_mode = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.getAsyncMode = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.extproc.options.gloo.solo.io.Overrides.prototype.setAsyncMode = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.extproc.options.gloo.solo.io.Overrides.prototype.clearAsyncMode = function() {
  this.setAsyncMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.hasAsyncMode = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string request_attributes = 3;
 * @return {!Array<string>}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.getRequestAttributesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.extproc.options.gloo.solo.io.Overrides.prototype.setRequestAttributesList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.addRequestAttributes = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.extproc.options.gloo.solo.io.Overrides.prototype.clearRequestAttributesList = function() {
  this.setRequestAttributesList([]);
};


/**
 * repeated string response_attributes = 4;
 * @return {!Array<string>}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.getResponseAttributesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array<string>} value */
proto.extproc.options.gloo.solo.io.Overrides.prototype.setResponseAttributesList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.addResponseAttributes = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


proto.extproc.options.gloo.solo.io.Overrides.prototype.clearResponseAttributesList = function() {
  this.setResponseAttributesList([]);
};


/**
 * optional GrpcService grpc_service = 5;
 * @return {?proto.extproc.options.gloo.solo.io.GrpcService}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.getGrpcService = function() {
  return /** @type{?proto.extproc.options.gloo.solo.io.GrpcService} */ (
    jspb.Message.getWrapperField(this, proto.extproc.options.gloo.solo.io.GrpcService, 5));
};


/** @param {?proto.extproc.options.gloo.solo.io.GrpcService|undefined} value */
proto.extproc.options.gloo.solo.io.Overrides.prototype.setGrpcService = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.extproc.options.gloo.solo.io.Overrides.prototype.clearGrpcService = function() {
  this.setGrpcService(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.hasGrpcService = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated string metadata_context_namespaces = 6;
 * @return {!Array<string>}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.getMetadataContextNamespacesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<string>} value */
proto.extproc.options.gloo.solo.io.Overrides.prototype.setMetadataContextNamespacesList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.addMetadataContextNamespaces = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


proto.extproc.options.gloo.solo.io.Overrides.prototype.clearMetadataContextNamespacesList = function() {
  this.setMetadataContextNamespacesList([]);
};


/**
 * repeated string typed_metadata_context_namespaces = 7;
 * @return {!Array<string>}
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.getTypedMetadataContextNamespacesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/** @param {!Array<string>} value */
proto.extproc.options.gloo.solo.io.Overrides.prototype.setTypedMetadataContextNamespacesList = function(value) {
  jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.extproc.options.gloo.solo.io.Overrides.prototype.addTypedMetadataContextNamespaces = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


proto.extproc.options.gloo.solo.io.Overrides.prototype.clearTypedMetadataContextNamespacesList = function() {
  this.setTypedMetadataContextNamespacesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.extproc.options.gloo.solo.io.HeaderForwardingRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.extproc.options.gloo.solo.io.HeaderForwardingRules.displayName = 'proto.extproc.options.gloo.solo.io.HeaderForwardingRules';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.prototype.toObject = function(opt_includeInstance) {
  return proto.extproc.options.gloo.solo.io.HeaderForwardingRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.extproc.options.gloo.solo.io.HeaderForwardingRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    allowedHeaders: (f = msg.getAllowedHeaders()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.ListStringMatcher.toObject(includeInstance, f),
    disallowedHeaders: (f = msg.getDisallowedHeaders()) && github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.ListStringMatcher.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.extproc.options.gloo.solo.io.HeaderForwardingRules}
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.extproc.options.gloo.solo.io.HeaderForwardingRules;
  return proto.extproc.options.gloo.solo.io.HeaderForwardingRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.extproc.options.gloo.solo.io.HeaderForwardingRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.extproc.options.gloo.solo.io.HeaderForwardingRules}
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.ListStringMatcher;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.ListStringMatcher.deserializeBinaryFromReader);
      msg.setAllowedHeaders(value);
      break;
    case 2:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.ListStringMatcher;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.ListStringMatcher.deserializeBinaryFromReader);
      msg.setDisallowedHeaders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.extproc.options.gloo.solo.io.HeaderForwardingRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.extproc.options.gloo.solo.io.HeaderForwardingRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllowedHeaders();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.ListStringMatcher.serializeBinaryToWriter
    );
  }
  f = message.getDisallowedHeaders();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.ListStringMatcher.serializeBinaryToWriter
    );
  }
};


/**
 * optional solo.io.envoy.type.matcher.v3.ListStringMatcher allowed_headers = 1;
 * @return {?proto.solo.io.envoy.type.matcher.v3.ListStringMatcher}
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.prototype.getAllowedHeaders = function() {
  return /** @type{?proto.solo.io.envoy.type.matcher.v3.ListStringMatcher} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.ListStringMatcher, 1));
};


/** @param {?proto.solo.io.envoy.type.matcher.v3.ListStringMatcher|undefined} value */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.prototype.setAllowedHeaders = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.extproc.options.gloo.solo.io.HeaderForwardingRules.prototype.clearAllowedHeaders = function() {
  this.setAllowedHeaders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.prototype.hasAllowedHeaders = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional solo.io.envoy.type.matcher.v3.ListStringMatcher disallowed_headers = 2;
 * @return {?proto.solo.io.envoy.type.matcher.v3.ListStringMatcher}
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.prototype.getDisallowedHeaders = function() {
  return /** @type{?proto.solo.io.envoy.type.matcher.v3.ListStringMatcher} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_external_envoy_type_matcher_v3_string_pb.ListStringMatcher, 2));
};


/** @param {?proto.solo.io.envoy.type.matcher.v3.ListStringMatcher|undefined} value */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.prototype.setDisallowedHeaders = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.extproc.options.gloo.solo.io.HeaderForwardingRules.prototype.clearDisallowedHeaders = function() {
  this.setDisallowedHeaders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.extproc.options.gloo.solo.io.HeaderForwardingRules.prototype.hasDisallowedHeaders = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.extproc.options.gloo.solo.io);
